import { Datalayer } from "../../layers/datalayer";
import { DatalayerZone } from "../../layers/datalayerZone";
import { IDataLayer, IDatalayerContext, IDataLayerZone, ZoneTextLocation } from "../../layers/types";
import { IRequirementsZone } from "../types";
import { RequirementsZone } from "./requirementsZone";

export class RequirementsLayer extends Datalayer {

    constructor(requirements: IDataLayer, _context: IDatalayerContext) {
        super(null, _context);
        super.initialize(requirements);
    }

    protected createZoneInstance(zone: IDataLayerZone): DatalayerZone {

        const reqZone = <IRequirementsZone>zone;

        return new RequirementsZone(this, reqZone, null);

    }

    getZoneText(zone: DatalayerZone, location: ZoneTextLocation): string {
        const v = this.viewer
        return v?.getZoneText(zone, location)
    }


}

